import React from 'react';
import { Link } from 'react-router-dom';
import { formatMs, calculaPrevision } from '../utils/time';
import CONFIG from '../config';
import MapaFavoritos from './MapaFavoritos';
import ElevationProfile from './ElevationProfile';

class ResultadoFavoritoList extends React.Component {
  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(window.location.search);
    const mapaActivo = urlParams.get('mapa') === 'true';

    this.state = {
      time: 0,
      mapaActivo: mapaActivo,
      isLoading: true
    };

    // Referencia al componente MapaFavoritos
    this.mapaRef = React.createRef();
  }

  componentDidMount() {
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 250);
    // Dar tiempo para que carguen los resultados
    setTimeout(() => this.setState({ isLoading: false }), 1000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  activarMapa = () => {
    this.setState({ mapaActivo: true });
  };

  desactivarMapa = () => {
    this.setState({ mapaActivo: false });
  };

  // Nuevo método para manejar el click en un atleta
  handleAtletaClick = (e, dorsal) => {
    if (this.state.mapaActivo && this.mapaRef.current) {
      e.preventDefault(); // ← DESCOMENTAR esta línea para prevenir la navegación

      // Hacer scroll suave hacia el mapa
      const mapaElement = document.querySelector('.mapa-container');
      if (mapaElement) {
        mapaElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }

      // Hacer zoom al atleta inmediatamente
      if (this.mapaRef.current) {
        this.mapaRef.current.flyToAtleta(dorsal);
      }
    }
  };

  _buildMapaJSX(resultadosPrevision, extraProps = {}) {
    return (
      <div className="mapa-container">
        <MapaFavoritos
          ref={this.mapaRef}
          geoJson={this.props.geoJson}
          turfLine={this.props.turfLine}
          turfBounds={this.props.turfBounds}
          turfDistanceRelation={this.props.turfDistanceRelation}
          resultados={resultadosPrevision}
          controles={this.props.controles}
          sectores={this.props.sectores}
          competicion={this.props.competicion}
          {...extraProps}
        />
      </div>
    );
  }

  _isMapReady() {
    const { controles, competicion, geoJson, turfDistanceRelation, turfBounds } = this.props;

    if (!geoJson || !competicion.mapa_visible) {
      return false;
    }

    const meta = controles.find(c => c.tipo === 'META');

    const readyForMap =
      meta && meta.prevision &&
      controles.length > 0 &&
      typeof turfDistanceRelation === 'number' &&
      !Number.isNaN(turfDistanceRelation) &&
      turfBounds;

    return readyForMap;
  }

  _renderMapToggleButton() {
    const { mapaActivo } = this.state;
    const { competicion } = this.props;
    const mapReady = this._isMapReady();

    // Si la carrera está finalizada, mostrar mensaje
    if (competicion.carrera_finalizada && competicion.mapa_visible) {
      return (
        <div className="mx-auto max-w-5xl px-0 md:px-40">
          <div className="text-center mb-8 px-3 bg-gray-900 rounded-lg">
            <div className="py-2 px-6 bg-gray-900 text-white rounded-lg font-montserrat text-base ring-1 ring-red-500 inline-block">
              Carrera finalizada
            </div>
            <div className="mt-2 text-sm font-light text-white italic">
              El mapa en directo ya no está disponible
            </div>
          </div>
        </div>
      );
    }

    if (!mapReady || mapaActivo) {
      return null;
    }

    return (
      <div className="mx-auto max-w-5xl px-0 md:px-40">
        <div className="text-center mb-8 px-3 bg-gray-900 rounded-lg">
          <button
            onClick={this.activarMapa}
            className="px-6 py-3 bg-ccnorte text-white border-none rounded-lg font-montserrat text-base cursor-pointer transition-all duration-300 shadow-md hover:-translate-y-0.5 hover:shadow-lg"
          >
            Ver geolocalización
          </button>
          <div className="mt-2 text-sm font-light text-white italic">
            Ubica a tus atletas favoritos con una posición aproximada que se basa en los datos recibidos de los controles anteriores
          </div>
        </div>
      </div>
    );
  }

  // Helper para aclarar colores
  _lightenColor(color, amount) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    const newR = Math.min(255, Math.floor(r + (255 - r) * amount));
    const newG = Math.min(255, Math.floor(g + (255 - g) * amount));
    const newB = Math.min(255, Math.floor(b + (255 - b) * amount));

    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
  }

  render() {
    const { sectores, controles, resultados, competicion } = this.props;
    const { mapaActivo } = this.state;

    if (resultados.length) {
      const resultadosPrevision = resultados.map((resultado) => ({
        ...resultado,
        prevision: calculaPrevision(competicion, controles, sectores, resultado),
      }));

      // Solo calculamos el mapa si está activo Y listo (esto incluye que NO esté finalizada)
      let mapaJSX = null;
      if (mapaActivo && this._isMapReady()) {
        if (competicion.prevision_control_iniciar) {
          const verMapa = resultadosPrevision.filter((a) =>
            a.prevision.distancia > a.prevision.inicioDistancia
          );
          if (verMapa && verMapa.length) {
            mapaJSX = this._buildMapaJSX(resultadosPrevision);
          }
        } else {
          mapaJSX = this._buildMapaJSX(resultadosPrevision);
        }
      }

      let colorIndex = -1;
      const colorValuesLength = CONFIG.COLORES_FAVORITOS.length;

      return (
        <div>
          {/* Botón de control del mapa */}
          {this._renderMapToggleButton()}

          {/* Mapa solo si está activo Y la carrera NO está finalizada */}
          {mapaJSX}
          {mapaJSX && <ElevationProfile competicion={competicion} resultados={resultadosPrevision} controles={controles} />}

          <div className="w-full">
            <div className="mx-auto max-w-5xl px-0 md:px-40">
              <ul className="space-y-3 mt-4">
                {resultadosPrevision.map((resultado) => {
                  colorIndex++;
                  const colorValue = CONFIG.COLORES_FAVORITOS[colorIndex % colorValuesLength];

                  const control = resultado.control_ultimo_id ? controles.find(c => parseInt(c.id, 10) === parseInt(resultado.control_ultimo_id, 10)) : null;
                  let tiempo = null;
                  if (resultado.control_ultimo_id) {
                    tiempo = resultado['control_' + resultado.control_ultimo_id + '_tiempo'];
                  }

                  let colorBarra = colorValue;
                  if (resultado.prevision.sector_idx) {
                    if (resultado.prevision.sector && resultado.prevision.sector.mapa_geojson) {
                      const map = JSON.parse(resultado.prevision.sector.mapa_geojson);
                      const properties = map.features[0].properties;
                      if (properties.color) {
                        colorBarra = properties.color;
                      }
                    }
                  }

                  // Verificar si debe mostrar barra de progreso
                  const mostrarProgreso = !competicion.carrera_finalizada &&
                    controles.some(c => c.prevision) &&
                    resultado.prevision.porcentaje !== null &&
                    resultado.prevision.porcentaje !== undefined &&
                    !(control && control.tipo === 'META');

                  return (
                    <li key={resultado.dorsal} className="list-none">
                      <Link
                        to={`/competicion/${competicion.id}/dorsal/${resultado.dorsal}`}
                        onClick={(e) => this.handleAtletaClick(e, resultado.dorsal)}
                        className="block px-4 py-3 hover:bg-slate-900/70 transition"
                      >
                        <div className="flex items-center gap-3">
                          {/* Avatar con iniciales */}
                          <div
                            className="grid place-items-center h-10 w-10 rounded-lg text-sm font-semibold text-white"
                            style={{ backgroundColor: colorValue }}
                          >
                            {resultado.nombre[0].toUpperCase()}
                            {resultado.apellidos ? resultado.apellidos[0].toUpperCase() : ''}
                          </div>

                          {/* Nombre + info */}
                          <div className="min-w-0 flex-1">
                            {resultado.preload ? (
                              <div className="h-4 w-48 rounded bg-slate-800 animate-pulse" />
                            ) : (
                              <div className="truncate text-white font-medium font-montserrat">
                                {resultado.nombre} {resultado.apellidos}
                              </div>
                            )}

                            {resultado.preload ? (
                              <div className="mt-2 h-3 w-64 rounded bg-slate-800 animate-pulse" />
                            ) : (
                              <div className="mt-1 text-sm text-slate-400 font-montserrat">
                                Dorsal <strong className="text-slate-200">{resultado.dorsal}</strong>
                                {resultado.categoria_nombre ? `, ${resultado.categoria_nombre}` : ''}
                                {resultado.clubNombre ? `, ${resultado.clubNombre}` : ''}
                                &nbsp;-&nbsp;
                                {resultado.descalificado ? (
                                  <span className="text-white font-medium">DESCALIFICADO</span>
                                ) : resultado.retirado ? (
                                  <span className="text-white font-medium">RETIRADO</span>
                                ) : control ? (
                                  control.tipo === 'META' ? (
                                    <span className="text-white font-medium">FINALIZADA</span>
                                  ) : (
                                    <span className="text-white font-medium">En {control.nombre}</span>
                                  )
                                ) : (
                                  <span className="text-white font-medium">TODAVÍA SIN DATOS</span>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Tiempo / estado */}
                          <div className="text-right">
                            {control && control.tipo === 'META' ? (
                              <div>
                                {resultado.descalificado ? (
                                  <div className="text-xs font-semibold uppercase tracking-wide text-red-400">
                                    DESCAL.
                                  </div>
                                ) : resultado.retirado ? (
                                  <div className="text-xs font-semibold uppercase tracking-wide text-slate-400">
                                    RETIRADO
                                  </div>
                                ) : (
                                  <div className="text-white font-mono text-sm">
                                    {(() => {
                                      let tiempoInicioCorrector = 0;
                                      if (competicion.tipo === 'TIEMPONETO' && resultado.start) {
                                        tiempoInicioCorrector = resultado.start - (competicion.guntime || 0);
                                      }
                                      const tiempoNeto = tiempo - tiempoInicioCorrector;
                                      return formatMs(tiempoNeto);
                                    })()}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div>
                                {!competicion.carrera_finalizada && resultado.prevision.tiempo !== null ? (
                                  <div className="text-right">
                                    <div className="text-[10px] uppercase tracking-wide text-slate-400 mb-1 font-mono">
                                      PREVISIÓN
                                    </div>
                                    <div className="text-red-400 font-mono text-sm">
                                      {formatMs(resultado.prevision.tiempo)}
                                    </div>
                                    {controles.some(c => c.prevision) && resultado.prevision.tiempoTotal && (
                                      <div className="text-red-400 font-mono text-xs mt-1">
                                        {formatMs(((competicion.tipo === "TIEMPONETO" && resultado.start) ? resultado.start : (resultado.guntime || competicion.guntime)) + resultado.prevision.tiempoTotal)} h
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  <div className="text-slate-400 font-mono text-sm">---</div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Barra de progreso */}
                        {mostrarProgreso && (
                          <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-slate-800">
                            <div
                              className="h-full transition-all duration-300 rounded-full"
                              style={{
                                width: `${resultado.prevision.porcentaje}%`,
                                backgroundColor: colorBarra
                              }}
                            />
                          </div>
                        )}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      );
      // } else {
      //   return (
      //     <div className="w-full">
      //       <div className="mx-auto max-w-5xl px-0 md:px-40">
      //         <div className="text-center py-12 text-slate-400 font-montserrat">
      //           Sigue a tus atletas favoritos para verlos aquí
      //         </div>
      //       </div>
      //     </div>
      //   );
      // }
    } else {
      if (this.state.isLoading) {
        return (
          <div className="flex justify-center items-center py-16">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
          </div>
        );
      }

      const mapReady = this._isMapReady();

      return (
        <div>
          {mapReady && this._buildMapaJSX([], { hideEmptyMessage: true })}
          <div className="w-full">
            <div className="mx-auto max-w-5xl px-0 md:px-40">
              <div className="text-center py-12 text-slate-400 font-montserrat">
                {mapReady
                  ? 'Sigue a tus atletas favoritos para verlos en el mapa. Búscalos en la pestaña Buscar.'
                  : 'Sigue a tus atletas favoritos para verlos aquí'}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default ResultadoFavoritoList;

